import { 
    ClientApiFp,
    ClientControllerGet200Response,
    CreateClientDto, 
    DeleteClientDto,
    EditClientDto,
    GetClientDto, 
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseClientModel = ClientControllerGet200Response;
export type GetClientModel = GetClientDto;
export type MutateResponseClientModel = MessageResponseDto;
export type CreateClientModel = CreateClientDto;
export type UpdateClientModel = EditClientDto;
export type DeleteClientModel = DeleteClientDto;

export const apiClientFp = ClientApiFp(apiConfig);
export const getClientController = apiClientFp.clientControllerGet;
export const createClientController = apiClientFp.clientControllerCreate;
export const updateClientController = apiClientFp.clientControllerEdit;
export const deleteClientController = apiClientFp.clientControllerDelete;

export const QueryKeyClient = QueryKey.Client;